import React, { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload, Form, Modal } from 'antd'
import axios from 'axios'
import { saveAs } from 'file-saver'

const App = () => {
  const [fileList, setFileList] = useState([])
  const [uploading, setUploading] = useState(false)
  const [blob, setBlob] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleUpload = () => {
    const formData = new FormData()
    fileList.forEach((file) => {
      formData.append('pdf', file)
    })
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/upload/pdftoimage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      })
      .then((res) => {
        setBlob(res.data)
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch((error) => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = (values) => {
    handleUpload()
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    setIsModalOpen(false)
    saveAs(new Blob([blob], { type: 'application/zip' }), '切割图片.zip') // 设置下载文件名
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  // 上传按钮属性
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      if (!isPdf) {
        message.error('只能上传pdf格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        message.error('上传文件最大100MB!')
        return false
      }
      setFileList([file])
      return false
    },
    fileList
  }
  return (
    <>
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>选取文件</Button>
      </Upload>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={fileList.length < 1}
            loading={uploading}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="切割完成"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="下载"
        cancelText="取消"
      >
      </Modal>
    </>
  )
}
export default App
